export default "__VITE_ASSET__CKfw_HGZ__"